export default {"src":"/_next/static/media/subSol3.8a8a0c58.svg","height":58,"width":52};